module.exports = __webpack_public_path__ + "static/media/icon-dashboard-location.484ecf68.svg";